import { render, staticRenderFns } from "./addedImages.vue?vue&type=template&id=53bcfe6f&scoped=true"
import script from "./addedImages.vue?vue&type=script&lang=js"
export * from "./addedImages.vue?vue&type=script&lang=js"
import style0 from "./addedImages.vue?vue&type=style&index=0&id=53bcfe6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bcfe6f",
  null
  
)

export default component.exports